export interface EvmCall {
    target: string;
    callData: string;
}
